import { createTheme } from "@mui/material/styles";
import { COLOR_BLACK } from "./colors";
import "./types";

export const FONT_FAMILY_PRIMARY = "Roboto, sans-serif";

export default createTheme({
  // Figma Typography
  typography: {
    fontFamily: FONT_FAMILY_PRIMARY,

    // Heading 1 / Medium / 36px
    heading1: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "2.25rem",
      fontWeight: 700,
      lineHeight: "130%",
      color: COLOR_BLACK,
    },
    // Heading 2 / Regular /28px
    heading2: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.75rem",
      fontWeight: 400,
      lineHeight: "130%",
      color: COLOR_BLACK,
    },
    // Heading 3 / Regular / 24px
    heading3: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.5rem",
      fontWeight: 500,
      lineHeight: "125%",
      color: COLOR_BLACK,
    },
    // Heading 4 / Medium / 20px
    heading4: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.25rem",
      fontWeight: 500,
      lineHeight: "130%",
      color: COLOR_BLACK,
    },
    // Heading 5 / Medium / 20px
    heading5: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.25rem",
      fontWeight: 500,
      lineHeight: "135%",
      color: COLOR_BLACK,
    },
    // Heading 6 / Medium / 18px
    heading6: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "135%",
      color: COLOR_BLACK,
    },

    // Body XLarge / SemiBold / 18px
    bodyXLSemiBold: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.125rem",
      fontWeight: 600,
      lineHeight: "140%",
      color: COLOR_BLACK,
    },
    // Body XLarge / Medium / 18px
    bodyXLMedium: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "140%",
      color: COLOR_BLACK,
    },
    // Body XLarge / Regular / 18px
    bodyXLRegular: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "140%",
      color: COLOR_BLACK,
    },

    // Body Large / SemiBold / 16px
    bodyLSemiBold: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1rem",
      fontWeight: 600,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Large / Medium / 16px
    bodyLMedium: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Large / Regular / 16px
    bodyLRegular: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },

    // Body Medium / SemiBold / 14px
    bodyMSemiBold: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.875rem",
      fontWeight: 700,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Medium / Medium / 14px
    bodyMMedium: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Medium / Regular / 14px
    bodyMRegular: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },

    // Body Small / SemiBold / 12px
    bodySSemiBold: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.75rem",
      fontWeight: 700,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Small / Medium / 12px
    bodySMedium: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.75rem",
      fontWeight: 500,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body Small / Regular / 12px
    bodySRegular: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },

    // Body XSmall / SemiBold / 10px
    bodyXSSemiBold: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.625rem",
      fontWeight: 700,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body XSmall / Medium / 10px
    bodyXSMedium: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.625rem",
      fontWeight: 500,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
    // Body XSmall / Regular / 10px
    bodyXSRegular: {
      fontFamily: FONT_FAMILY_PRIMARY,
      fontSize: "0.625rem",
      fontWeight: 400,
      lineHeight: "150%",
      color: COLOR_BLACK,
    },
  },
});
